import { render } from "./svg-rocket.vue?vue&type=template&id=1685e39d"
import script from "./svg-rocket.vue?vue&type=script&lang=ts"
export * from "./svg-rocket.vue?vue&type=script&lang=ts"
script.render = render

export default script